module.exports = __webpack_public_path__ + "email.svg?665a63cbabed8a92f28df303575393b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email.svg
// module id = 78
// module chunks = 6